import SpendingLimitsScreen from 'features/believe/learningCenter/SpendingLimitsScreen/SpendingLimitsScreen';
import React from 'react';

export default function Page() {
  return <SpendingLimitsScreen />;
}
